'use es6';

import PropTypes from 'prop-types';
export default PropTypes.oneOf(['FAIL', 'PASS', 'PENDING']);